import React from "react";

/**
 * MedalIcon — рисованные inline-SVG медали Рублокса ПО КЛЮЧУ из каталога
 * бэка (routs/RubloxMedals.py MEDALS). Никаких эмодзи и внешних картинок.
 *
 * Медаль = две ленточки + круг с градиентом ТИРА (бронза/серебро/золото/
 * ивент) + белый глиф сюжета медали. Незаработанные обесцвечивает
 * родитель фильтром grayscale (как у AchievIcon).
 *
 * Градиенты имеют префикс rm-<key>, чтобы id не пересекались между
 * несколькими медалями на одной странице.
 */

const TIER_COLORS = {
  bronze: ["#e39a5b", "#a05a2c"],
  silver: ["#e5e9f0", "#9aa5b5"],
  gold:   ["#ffd76a", "#e8960c"],
  event:  ["#c084fc", "#7c3aed"],
};
const RIBBON_COLORS = {
  bronze: "#b4632f",
  silver: "#7d8896",
  gold:   "#d97706",
  event:  "#6d28d9",
};

/* Глиф сюжета медали — белым внутри круга (viewBox круга: 24x24,
 * центр 12,12). Ключи = MEDALS на бэке. */
function Glyph({ medalKey }) {
  switch (medalKey) {
    // Запуски игр: play-треугольник + цифра тира читается из title,
    // на глифе — треугольник и «толпа» точек снизу по тиру.
    case "plays_100":
      return (
        <g fill="#fff">
          <path d="M9.4 6.8 17 12l-7.6 5.2z" />
          <circle cx="8" cy="19.4" r="1.15" />
          <circle cx="12" cy="19.4" r="1.15" />
        </g>
      );
    case "plays_1000":
      return (
        <g fill="#fff">
          <path d="M9.4 6.4 17 11.6l-7.6 5.2z" />
          <circle cx="7" cy="19.2" r="1.15" />
          <circle cx="11" cy="19.2" r="1.15" />
          <circle cx="15" cy="19.2" r="1.15" />
        </g>
      );
    case "plays_10000":
      return (
        <g fill="#fff">
          <path d="M9.4 6.2 17 11.4l-7.6 5.2z" />
          <circle cx="5.6" cy="19" r="1.1" />
          <circle cx="9.4" cy="19" r="1.1" />
          <circle cx="13.2" cy="19" r="1.1" />
          <circle cx="17" cy="19" r="1.1" />
        </g>
      );
    // Хит недели: пламя
    case "hit_week_25":
      return (
        <path fill="#fff" d="M12 4.6c.6 2.4-.6 3.7-1.7 5C9.2 10.9 8 12.2 8 14.4a4.4 4.4 0 0 0 8.8 0c0-1.5-.6-2.6-1.3-3.7-.3.9-.8 1.4-1.5 1.8.3-2.9-.5-6-2-7.9z" />
      );
    // Суперхит: пламя + звезда
    case "hit_week_100":
      return (
        <g fill="#fff">
          <path d="M11.2 5c.5 2.1-.5 3.2-1.5 4.4-1 1.1-2 2.3-2 4.2a4 4 0 0 0 8 0c0-1.3-.5-2.3-1.1-3.3-.3.8-.7 1.3-1.4 1.6.3-2.6-.5-5.2-2-6.9z" />
          <path d="m17.6 5.2.7 1.5 1.6.3-1.2 1.1.3 1.6-1.4-.8-1.5.8.3-1.6-1.2-1.1 1.7-.3z" />
        </g>
      );
    // Призёр арены: пьедестал
    case "lb_top3":
      return (
        <g fill="#fff">
          <rect x="9.4" y="8.6" width="5.2" height="9.4" rx="0.7" />
          <rect x="4.4" y="11.8" width="4.6" height="6.2" rx="0.7" />
          <rect x="15" y="13.4" width="4.6" height="4.6" rx="0.7" />
          <path d="M11.6 5.2h.9v1.6h-1.4v-.9z" />
        </g>
      );
    // Чемпион арены: кубок
    case "lb_top1":
      return (
        <path fill="#fff" d="M8 5h8v1.4h2.6c0 2.9-1.3 4.6-3 5.2a4.1 4.1 0 0 1-2.3 1.9v2h2.2c.5 0 .9.4.9.9v1.4H7.6v-1.4c0-.5.4-.9.9-.9h2.2v-2a4.1 4.1 0 0 1-2.3-1.9c-1.7-.6-3-2.3-3-5.2H8zm-1.1 2.7c.1 1.4.7 2.3 1.4 2.8-.2-.8-.3-1.8-.3-2.8zm10.2 0h-1.1c0 1-.1 2-.3 2.8.7-.5 1.3-1.4 1.4-2.8z" />
      );
    // Гроза арен: кубок + звёзды
    case "lb_top1_5":
      return (
        <g fill="#fff">
          <path d="M9 7h6v1h2c0 2.2-1 3.5-2.3 4a3.2 3.2 0 0 1-1.8 1.5v1.6h1.7c.4 0 .7.3.7.7v1.1H8.7v-1.1c0-.4.3-.7.7-.7h1.7v-1.6A3.2 3.2 0 0 1 9.3 12C8 11.5 7 10.2 7 8h2z" />
          <path d="m6 4.2.5 1 1.1.2-.8.8.2 1.1-1-.5-1 .5.2-1.1-.8-.8 1.1-.2zM18 4.2l.5 1 1.1.2-.8.8.2 1.1-1-.5-1 .5.2-1.1-.8-.8 1.1-.2z" />
        </g>
      );
    // Ивентные
    case "event_star":
      return (
        <path fill="#fff" d="m12 4.8 2 4.1 4.5.7-3.3 3.2.8 4.5-4-2.1-4 2.1.8-4.5-3.3-3.2 4.5-.7z" />
      );
    case "event_winner":
      return (
        <path fill="#fff" d="M5 8.4 8.4 11 12 6.4 15.6 11 19 8.4l-1.2 8H6.2zm1.2 9.4h11.6v1.6H6.2z" />
      );
    case "event_helper":
      return (
        <path fill="#fff" d="M12 18.6 6.6 13a3.7 3.7 0 0 1 0-5.2 3.6 3.6 0 0 1 5.1 0l.3.3.3-.3a3.6 3.6 0 0 1 5.1 0 3.7 3.7 0 0 1 0 5.2z" />
      );
    // Фолбэк: звезда (на случай новой медали без глифа)
    default:
      return (
        <path fill="#fff" d="m12 5.4 1.8 3.7 4 .6-2.9 2.9.7 4-3.6-1.9-3.6 1.9.7-4-2.9-2.9 4-.6z" />
      );
  }
}

export default function MedalIcon({ medalKey, tier = "bronze", size = 44 }) {
  const [c1, c2] = TIER_COLORS[tier] || TIER_COLORS.bronze;
  const ribbon = RIBBON_COLORS[tier] || RIBBON_COLORS.bronze;
  const gid = `rm-${medalKey || "m"}-${tier}`;
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor={c1} />
          <stop offset="1" stopColor={c2} />
        </linearGradient>
      </defs>
      {/* ленточки */}
      <path d="M11.4 18.5 8.2 29l3.6-1.6 2 3.2 2.6-8.6z" fill={ribbon} />
      <path d="M20.6 18.5 23.8 29l-3.6-1.6-2 3.2-2.6-8.6z" fill={ribbon} opacity="0.8" />
      {/* круг медали с ободком */}
      <circle cx="16" cy="12.6" r="9.8" fill={`url(#${gid})`} />
      <circle cx="16" cy="12.6" r="7.9" fill="none" stroke="rgba(255,255,255,0.55)" strokeWidth="1.1" />
      {/* глиф сюжета (viewBox 24 → сдвиг в центр круга) */}
      <g transform="translate(4 0.6)">
        <Glyph medalKey={medalKey} />
      </g>
    </svg>
  );
}
